module.exports = __webpack_public_path__ + "img/1.387680da.jpg";